import { render, staticRenderFns } from "./RegisterOrLogin.vue?vue&type=template&id=ccd1b2ca"
import script from "./RegisterOrLogin.vue?vue&type=script&lang=js"
export * from "./RegisterOrLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports